import React, { useState, useEffect } from "react";
import Input from "../common/input";

const PillList = ({ action, label, options, pillList, onChange, placeholder }) => {
  const [originalOpts, setOriginalOpts] = useState(options);
  const [opts, setOpts] = useState(options);
  const [list, setList] = useState(pillList);
  const [selectValue, setSelectValue] = useState("");
  const [extras, setExtras] = useState([]);
  const [extraSelections, setExtraSelections] = useState([]);

  const handleSelectChange = (selectedOption, name) => {
    if (selectedOption.extras.length > 0) {
      setSelectValue(selectedOption);
      setExtras(selectedOption.extras);
    } else {
      setExtras([]);
      const newList = [...list];
      newList.push(selectedOption);
      setList(newList);
      const newOpts = [...opts];
      const index = newOpts.findIndex((item) => item.value === selectedOption.value);
      newOpts.splice(index, 1);
      setOpts(newOpts);
      setSelectValue("");
      onChange(newList);
    }
  };

  const handleKeyPress = (e) => {
    if (!((e.keyCode === 13 || e.keyCode === 9) && extras)) setExtras([]);
  };

  const handleSelectChangeExtra = (selectedOption, index) => {
    let extraSel = [...extraSelections];
    extraSel[index] = selectedOption;
    setExtraSelections(extraSel);
  };

  const handleAddWithExtras = () => {
    const newList = [...list];
    const newItem = selectValue;
    delete newItem.extras;
    newItem.extras = extraSelections.map((item) => item.label).join(" ");
    newList.push(newItem);
    setList(newList);
    const newOpts = [...opts];
    const index = newOpts.findIndex((item) => item.value === selectValue.value);
    newOpts.splice(index, 1);
    setOpts(newOpts);
    setExtraSelections([]);
    setSelectValue("");
    setExtras([]);
    onChange(newList);
  };

  const deletePill = (value) => {
    const newList = [...list];
    const index = newList.findIndex((item) => item.value === value);

    const orgOptsIndex = options.findIndex((item) => item.value === value);

    const newOpts = [...opts];
    // newOpts.push(newList[index]);
    newOpts.push(originalOpts[orgOptsIndex]);

    newOpts.sort((a, b) => {
      let fa = a.label.toLowerCase(),
        fb = b.label.toLowerCase();
      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
    newList.splice(index, 1);
    setList(newList);
    setOpts(newOpts);
    onChange(newList);
  };

  useEffect(() => {
    if (pillList.length > 0) {
      const filteredList = originalOpts.filter((opt) => !pillList.some((item) => item.value === opt.value));
      setOpts(filteredList);
    }
  }, []);

  // if (record.ambientes && record.ambientes.length > 0) {
  //   const listAmbientes = allAmbientes.filter(
  //     (ambiente) => !record.ambientes.some((item) => item.value === ambiente.value)
  //   );
  //   this.setState({ listAmbientes });
  // } else

  return (
    <>
      {list && (
        <div className="col-12 mb-2 mt-2">
          <div className="group-box">
            <label className="group-box-label">{label}</label>
            {action != "C" && (
              <>
                <div className="row mt-2 mr-1 ml-1">
                  <div className="col-4">
                    <Input
                      combo
                      preventForward
                      value={selectValue}
                      options={opts}
                      float
                      label={placeholder}
                      onChange={handleSelectChange}
                      overrideKeyDown={handleKeyPress}
                    />
                  </div>
                  <div className="col-8">
                    <div className="row">
                      {extras.length > 0 &&
                        extras.map((item, index) => {
                          if (item.tipo === "combo")
                            return (
                              <>
                                <div key={Math.random()} className="col-4">
                                  <Input
                                    combo
                                    options={item.options}
                                    // name={`extra${index + 1}`}
                                    value={extraSelections[index]}
                                    onChange={(e) => handleSelectChangeExtra(e, index)}
                                  />
                                </div>
                                {index === extras.length - 1 ? (
                                  <div className="col-2 my-auto">
                                    <div className="form-group">
                                      <button
                                        type="button"
                                        className="btn btn-small btn-secondary"
                                        onClick={handleAddWithExtras}
                                      >
                                        Agregar
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                            );
                        })}
                    </div>
                  </div>
                </div>
                {list.length > 0 && <hr />}
              </>
            )}
            <div className="container-fluid mb-2">
              {list.map((element) => {
                if (element.extra) console.log(element.extra);
                return (
                  <span key={Math.random()} className="badge  badge-secondary p-3 m-1">
                    <strong>
                      {element.label + (element.extras && element.extras.length > 0 ? ": " + element.extras : "")}
                    </strong>
                    {action != "C" && (
                      <i className="fas fa-times ml-2 clickable" onClick={() => deletePill(element.value)}></i>
                    )}
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PillList;
